module.exports = __webpack_public_path__ + "static/media/product-detail.214244e8.webp";